import React, { PropTypes } from 'react'
import * as loader from 'loader'

const ModuleLoader = ({ bundle, r }) => {
    const module = loader.loadModule(bundle)
    return r(module)
}

ModuleLoader.propTypes = {
    bundle: PropTypes.string.isRequired,
    r: PropTypes.func.isRequired
}

export default ModuleLoader